module.exports = __webpack_public_path__ + "static/image/history/m/202209@3x.jpg?0edd0780";